import React from 'react';

const BlogDetailsSkeleton = () => {
  return (
    <div className='lg:w-[70%] w-full flex flex-col gap-y-5'>
      {/* TextImageBanner Skeleton */}
      {/* <div className="w-full h-64 bg-gray-200 animate-pulse"></div> */}

      <div className="relative flex flex-col-reverse lg:flex-row xl:gap-20 gap-10">
        {/* Main Content Area Skeleton */}
        <div className="w-full flex flex-col gap-y-8">

          {/* BlogDetailHeroSection Skeleton */}
          <div className="flex flex-col gap-y-4">
            <div className="w-full md:h-[400px] h-[210px] rounded-3xl bg-gray-200 animate-pulse"></div>
            <div className="flex flex-wrap items-center gap-5">
              {[1, 2, 3].map((item) => (
                <div key={item} className="h-6 w-20 bg-gray-200 rounded animate-pulse"></div>
              ))}
            </div>
          </div>

          {/* BlogDetailArticleSection Skeleton */}
          <div className="flex flex-col gap-y-6">
            {/* Title */}
            <div className="h-10 bg-gray-200 rounded animate-pulse"></div>

            {/* Description with drop cap */}
            <div className="flex gap-3">
              <div className="w-12 h-12 bg-gray-200 rounded-md animate-pulse flex-shrink-0"></div>
              <div className="flex-1 space-y-3">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-full"></div>
                <div className="h-4 bg-gray-200 rounded animate-pulse w-5/6"></div>
                <div className="h-4 bg-gray-200 rounded animate-pulse w-4/6"></div>
              </div>
            </div>

            {/* Additional paragraphs */}
            {[1, 2, 3].map((item) => (
              <div key={item} className="space-y-2">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-full"></div>
                <div className="h-4 bg-gray-200 rounded animate-pulse w-11/12"></div>
              </div>
            ))}

            {/* Quote block skeleton */}
            <div className="bg-gray-200 rounded-3xl p-10 h-48 animate-pulse flex items-center justify-center">
              <div className="text-center space-y-3">
                <div className="h-6 bg-gray-300 rounded animate-pulse w-32 mx-auto"></div>
                <div className="h-4 bg-gray-300 rounded animate-pulse w-24 mx-auto"></div>
              </div>
            </div>

            {/* Feature section */}
            <div className="space-y-4">
              <div className="h-8 bg-gray-200 rounded animate-pulse w-1/2"></div>
              <div className="h-4 bg-gray-200 rounded animate-pulse w-full"></div>
              <div className="h-4 bg-gray-200 rounded animate-pulse w-5/6"></div>
            </div>
          </div>

          {/* BlogDetailsServiceList Skeleton */}
          <div className="flex flex-col md:flex-row items-start gap-6">
            {/* Image */}
            <div className="sm:h-[350px] h-[250px] md:w-[420px] w-full rounded-3xl bg-gray-200 animate-pulse"></div>

            {/* Service list */}
            <div className="flex-1 flex flex-col gap-y-4">
              {[1, 2, 3, 4, 5, 6].map((item) => (
                <div key={item} className="flex gap-3 items-center">
                  <div className="w-6 h-6 bg-gray-200 rounded-full animate-pulse"></div>
                  <div className="h-4 bg-gray-200 rounded animate-pulse w-48"></div>
                </div>
              ))}
            </div>
          </div>

          {/* <div className="space-y-6">
            <div className="h-8 bg-gray-200 rounded animate-pulse w-1/3"></div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[1, 2, 3, 4].map((item) => (
                <div key={item} className="h-12 bg-gray-200 rounded-lg animate-pulse"></div>
              ))}
            </div>
            <div className="h-32 bg-gray-200 rounded-lg animate-pulse"></div>
            <div className="h-12 bg-gray-200 rounded-lg animate-pulse w-40"></div>
          </div> */}
        </div>

        {/* <div className="lg:w-[30%] w-full space-y-8">
          <div className="h-12 bg-gray-200 rounded-full animate-pulse"></div>

          <div className="space-y-4">
            <div className="h-6 bg-gray-200 rounded animate-pulse w-1/2"></div>
            {[1, 2, 3].map((item) => (
              <div key={item} className="flex gap-3 items-center">
                <div className="w-16 h-16 bg-gray-200 rounded-lg animate-pulse"></div>
                <div className="flex-1 space-y-2">
                  <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4"></div>
                  <div className="h-3 bg-gray-200 rounded animate-pulse w-20"></div>
                </div>
              </div>
            ))}
          </div>

          <div className="space-y-4">
            <div className="h-6 bg-gray-200 rounded animate-pulse w-1/2"></div>
            {[1, 2, 3, 4, 5].map((item) => (
              <div key={item} className="flex justify-between items-center">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-32"></div>
                <div className="h-6 w-6 bg-gray-200 rounded-full animate-pulse"></div>
              </div>
            ))}
          </div>

          <div className="space-y-4">
            <div className="h-6 bg-gray-200 rounded animate-pulse w-1/2"></div>
            <div className="flex flex-wrap gap-2">
              {[1, 2, 3, 4, 5, 6].map((item) => (
                <div key={item} className="h-8 bg-gray-200 rounded-full animate-pulse w-16"></div>
              ))}
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default BlogDetailsSkeleton;